<template>  
    <div> 
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<div class="stepForm" v-if="success == '3'">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('toolVps_reqProcessing')}}</h3>
            </div> 
           
        </div>
        <div class="stepForm" v-if="success == true">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('toolVps_reqVerify')}}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 middleBox">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../../static/fxView/images/congrats.png" alt="Icon">
                    </div>
                    <div class="subtitle">
                        <h3>{{$t('verf_dear')}} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{$t('createzullu_Your')}} {{type}} {{$t('acc_accountVerMsz1')}}</p>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/wallet'" class="prism_btn btn_sm">{{ $t('fxBackToWallet') }}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="stepForm" v-if="success == false">
            <div class="mainTitle text-center mt-4 mb-3"> 
                <h3 class="mb-4">{{$t('toolVps_reqFailed')}}</h3>
            </div> 
            <div class="CustomBlockWidth inMiddle-area whitebox p-4">  
                <div class="congratulations">
                    <div class="logo_congrats">
                        <img src="../../../../../static/fxView/images/cross.svg" alt="Request Failed">
                    </div>
                    <div class="subtitle">
                        <h3>{{$t('verf_dear')}} <span class="green">{{get_user.username}}</span></h3>
                        <p>{{$t(msg)}}</p> 
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="'/wallet'" class="prism_btn btn_sm">{{$t('loyal_ver_back')}}</router-link>
                    </div>
                </div>
            </div> 
        </div>
    </div> 
</template>
<script>
    export default {
        name: 'accounts',
        data() {
            return {
               verify : '',
               type : '',
               success : '3',
               msg : '',
               pageLoader : false,
               response_msg : '',
                msg_type : '',
            }
        },
        created(){
            let query = Object.assign({}, this.$route.query);
            if(this.$route.query.verify){

                //console.log(query)

                this.verify = query.verify
                this.type = query.type
                let input_json = {
                    'globalParams' : {
                        'verify' : this.verify.toString()
                    },
                    'localParams' : {'parameter' : this , 'params' :'request-verify'}
                }

                if(this.type == 'REDEEM LOYALTY'){
                    this._runLoyalityRedeemCheckOtp(input_json)
                }else if(this.type == 'TRANSFER LOYALTY'){
                    this._runLoyalityTransaferCheckOtp(input_json)
                }
                
                delete query.verify;
                delete query.type;
                this.$router.replace({ query });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyality/loyalty-verify.vue